
      document.addEventListener('DOMContentLoaded', function () {
        if (localStorage.getItem('openCart') === 'true') {
          document.documentElement.classList.add('cart-show');

          localStorage.removeItem('openCart');
        }

        const addToCartBtn = document.getElementById('AddToCart');

        window.addEventListener('scroll', function () {
          if (window.scrollY > 300) {
            addToCartBtn.classList.add('sticky-cart');
          } else {
            addToCartBtn.classList.remove('sticky-cart');
          }
        });

        $(document).on('click', '.collection-add-to-cart-btn', function () {
          var button = $(this);
          var variantId = button.data('variant-id');

          if (!variantId) return;

          button.text('Adding...');

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: variantId,
              quantity: 1,
            },
            dataType: 'json',

            success: function () {
              // $.getJSON('/cart.js', function (cart) {
                // var cartItemsHtml = '';

                // $.each(cart.items, function (index, item) {
                //   var variantTitle = item.variant_title ? item.variant_title : '';

                //   cartItemsHtml += `
                //     <li class="item" id="cart-item-${item.variant_id}">

                //       <a href="${item.url}" class="product-image">
                //         <img src="${item.image}" alt="${item.product_title}">
                //       </a>

                //       <div class="product-details">

                //         <a href="javascript:void(0)"
                //           title="Remove"
                //           class="btn-remove"
                //           data-key="${item.key}">
                //           ×
                //         </a>

                //         <a class="product-name" href="${item.url}">
                //           ${item.product_title}
                //         </a>

                //         <div class="option">
                //           ${variantTitle ? `<small>${variantTitle}</small>` : ''}
                //         </div>

                //         <div class="cart-collateral">

                //           <div class="qty-box" data-key="${item.key}">
                //             <button class="qty-btn minus">-</button>
                //             <input type="number" class="qty-input" value="${item.quantity}" min="1">
                //             <button class="qty-btn plus">+</button>
                //           </div>

                //           <span class="price" id="line-price-${item.key}">
                //             Rs. ${(item.final_line_price / 100).toFixed(2)}
                //           </span>

                //         </div>

                //       </div>

                //     </li>
                //   `;
                // });

                // Update cart items
                // $('#slidedown-cart .mini-products-list').html(cartItemsHtml);

                // Update total price
                // $('#slidedown-cart .summary .price').html(
                //   'Rs. ' + (cart.total_price / 100).toFixed(2)
                // );

                // Show/Hide empty cart state
                // if (cart.item_count > 0) {
                //   $('#slidedown-cart .has-items').show();
                //   $('#slidedown-cart .no-items').hide();
                // } else {
                //   $('#slidedown-cart .has-items').hide();
                //   $('#slidedown-cart .no-items').show();
                // }

                // Open cart drawer
                // $('html').addClass('cart-show');
                // handleFloCartBtn();


                // Button text
                // button.text('Added');

                // Optional reset button text
                // setTimeout(function () {
                //   button.text('Add to Cart');
                // }, 1500);
              // });

                handleFloCartBtn();


                // Button text
                button.text('Added');

                // Optional reset button text
                setTimeout(function () {
                  button.text('Add to Cart');
                }, 1500);
            },

            error: function () {
              button.text('Add to Cart');

              alert('Unable to add product to cart.');
            },
          });
        });

        $(document).on('click', '.btn-remove', function (e) {
          e.preventDefault();

          var itemKey = $(this).data('key');

          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: itemKey,
              quantity: 0,
            },
            dataType: 'json',

            success: function (cart) {
              var cartItemsHtml = '';

              $.each(cart.items, function (index, item) {
                var variantTitle = item.variant_title ? item.variant_title : '';

                cartItemsHtml += `
          <li class="item" id="cart-item-${item.variant_id}">

            <a href="${item.url}" class="product-image">
              <img src="${item.image}" alt="${item.product_title}">
            </a>

            <div class="product-details">

              <a href="javascript:void(0)" title="Remove" class="btn-remove" data-key="${item.key}">
                ×
              </a>

              <a class="product-name" href="${item.url}">
                ${item.product_title}
              </a>

              <div class="option">
                ${variantTitle ? `<small>${variantTitle}</small>` : ''}
              </div>

              <div class="cart-collateral">

                <div class="qty-box" data-key="${item.key}">
                  <button class="qty-btn minus">-</button>

                  <input type="number" class="qty-input" value="${item.quantity}" min="1">

                  <button class="qty-btn plus">+</button>
                </div>

                <span class="price">
                  ${Shopify.formatMoney(item.final_line_price)}
                </span>

              </div>

            </div>

          </li>
        `;
              });

              $('.mini-products-list').html(cartItemsHtml);

              $('#slidedown-cart .summary .price').html(Shopify.formatMoney(cart.total_price));

              if (cart.item_count > 0) {
                $('#slidedown-cart .has-items').show();
                $('#slidedown-cart .no-items').hide();
              } else {
                $('#slidedown-cart .has-items').hide();
                $('#slidedown-cart .no-items').show();
              }
            },
          });
        });
      });


            document.addEventListener('click', function (e) {
        if (e.target.classList.contains('plus') || e.target.classList.contains('minus')) {
          let box = e.target.closest('.qty-box');
          let input = box.querySelector('.qty-input');
          let key = box.dataset.key;

          let qty = parseInt(input.value);

          if (e.target.classList.contains('plus')) {
            qty++;
          }

          if (e.target.classList.contains('minus') && qty > 1) {
            qty--;
          }

          input.value = qty;

          updateCart(key, qty);
        }
      });

      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('qty-input')) {
          let box = e.target.closest('.qty-box');
          let key = box.dataset.key;
          let qty = parseInt(e.target.value);

          updateCart(key, qty);
        }
      });

      function updateCart(key, qty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: qty,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            localStorage.setItem('openCart', 'true');
            location.reload();
          });
      }

              $('.close-cart').click(function () {
          $('html').removeClass('cart-show');
        });